module.exports = __webpack_public_path__ + "img/mobile-bg.1203853a.png";